import React, { useState, useEffect } from "react"; 
import { Timer, Clock, Palette, Import } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import useAuthUser from "./useAuthUser"; 
import NotificationBanner from "./NotificationBanner";
export default function Header({
  mode,
  setMode,
  setTimerSeconds,
  setBaseSeconds,
  setRunning,
  setEditing,
  theme,
  displayMode,
  setDisplayMode,
  openThemeModal,
  onOpenCustomModal,
  onSetPresetPair,
  handleShare,
}) {
  const presetWidth = 255; // This is the bar width, adjust if needed

  // Track selected preset (null, "pomodoro", "long", "custom")
  const [selectedPreset, setSelectedPreset] = React.useState(null);

  // Clear selected preset if not in settime mode
  React.useEffect(() => {
    if (mode !== "settime") setSelectedPreset(null);
  }, [mode]);
  const navigate = useNavigate();
  const user = useAuthUser(); 
  const [notif, setNotif] = useState("");
  const [showNotif, setShowNotif] = useState(false);
function showNotification(message) {
  setNotif(message);
  setShowNotif(true);
} 
useEffect(() => {
  if (!showNotif) return;
  const timeout = setTimeout(() => setShowNotif(false), 2500);
  return () => clearTimeout(timeout);
}, [showNotif]);
  return (
    <>
    <NotificationBanner
      notif={notif}
      show={showNotif}
      onClose={() => setShowNotif(false)}
      theme={theme}
    /> 
  <div className="flex flex-col md:flex-row items-center justify-between px-2 sm:px-8 py-4 gap-4 w-full">
    {/* Logo */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <span
            className="rounded-lg px-2 py-1 font-extrabold tracking-tight text-lg"
            style={{
              backgroundColor: theme.colors.logoBackground,
              color: theme.colors.logoText,
            }}
          >
            tuff
          </span>
          <span
            className="text-3xl font-semibold tracking-tight"
            style={{ color: theme.colors.text }}
          >
            timer.com
          </span>
        
        </div>
      </div>
      {/* Controls */}
      <div className="flex-1 flex justify-center items-center">
      <div className="flex flex-wrap items-center gap-2 sm:gap-4 w-full justify-center">
      {/* Set Time Button */}
          <motion.div layout="position">
            <button
              className="flex items-center gap-2 px-3 py-2 rounded-lg font-semibold transition"
              style={{
                backgroundColor:
                  mode === "settime" && !selectedPreset
                    ? theme.colors.logoBackground
                    : "transparent",
                color:
                  mode === "settime" && !selectedPreset
                    ? theme.colors.logoText
                    : theme.colors.text,
              }}
              onClick={() => {
                setMode("settime");
                if (setEditing) setEditing(true);
                setSelectedPreset(null);
              }}
            >
              <Clock size={18} /> Timer
            </button>
          </motion.div>


          {/* Presets */}
          <motion.div
            layout
            style={{
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              width: mode === "settime" ? presetWidth : 0,
              marginRight: mode === "settime" ? 8 : 0,
              transition: "width 0.45s cubic-bezier(.42,0,.32,1.36), margin 0.38s cubic-bezier(.42,0,.32,1.36)",
              whiteSpace: "nowrap",
            }}
          >
            <AnimatePresence initial={false}>
              {mode === "settime" && (
                <motion.div
                  className="flex items-center gap-2"
                  initial={{ opacity: 0, x: 60 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 60 }}
                  transition={{
                    type: "spring",
                    stiffness: 120,
                    damping: 18,
                  }}
                  style={{ whiteSpace: "nowrap" }}
                >
                  <button
                  className="flex items-center gap-2 px-3 py-2 rounded-lg font-semibold transition"
style={{
                      backgroundColor:
                        selectedPreset === "pomodoro"
                          ? theme.colors.logoBackground
                          : "transparent",
                      color:
                        selectedPreset === "pomodoro"
                          ? theme.colors.text
                          : theme.colors.logo,
                      border:
                        selectedPreset === "pomodoro"
                          ? `2px solid ${theme.colors.logoBackground}`
                          : `2px solid transparent`,
                    }}
                    onClick={() => {
                      onSetPresetPair(25, 5); // ← set timer + break from App.js
                      setSelectedPreset("pomodoro");
                    }}
                  >
                    25 | 5
                  </button>
                  <button
                  className="flex items-center gap-2 px-3 py-2 rounded-lg font-semibold transition"
                    style={{
                      backgroundColor:
                        selectedPreset === "long"
                          ? theme.colors.logoBackground
                          : "transparent",
                      color:
                        selectedPreset === "long"
                        ? theme.colors.text
                        : theme.colors.logo,
                      border:
                        selectedPreset === "long"
                          ? `2px solid ${theme.colors.logoBackground}`
                          : `2px solid transparent`,
                    }}
                    onClick={() => {
                      onSetPresetPair(90, 30); // ← set timer + break from App.js
                      setSelectedPreset("long");
                    }}
                  >
                    90 | 30
                  </button>
                  {/* ---  "Custom" BUTTON BELOW --- */}
                  <button
                    className="px-3 py-1 rounded font-semibold transition"
                    style={{
                      backgroundColor:
                        selectedPreset === "custom"
                          ? theme.colors.logoBackground
                          : "transparent",
                      color:
                        selectedPreset === "custom"
                          ? theme.colors.logoText
                          : theme.colors.text,
                      border:
                        selectedPreset === "custom"
                          ? `2px solid ${theme.colors.logo}`
                          : `2px solid transparent`,
                    }}
                    onClick={() => {
                      setTimerSeconds(0);
                      setBaseSeconds(0);
                      setRunning(false);
                      setSelectedPreset("custom");
                      if (setEditing) setEditing(true);
                      if (onOpenCustomModal) onOpenCustomModal();
                    }}
                  >
                    Custom
                  </button>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>

          {/* Stopwatch Button */}
          <motion.div layout="position">
            <button
              className="flex items-center gap-2 px-3 py-2 rounded-lg font-semibold transition"
              style={
                mode === "stopwatch"
                  ? {
                      backgroundColor: theme.colors.logoBackground,
                      color: theme.colors.logoText,
                    }
                  : { color: theme.colors.text }
              }
              onClick={() => {
                setMode("stopwatch");
                setTimerSeconds(0);
                setBaseSeconds(0);
                setRunning(false);
              }}
            >
              <Timer size={18} /> Stopwatch
            </button>
          </motion.div>
          {/* Theme, Text, Pie */}
          <motion.div layout="position" className="flex items-center gap-2">
            <button
              className="flex items-center gap-2 px-3 py-2 rounded-lg font-semibold transition"
              style={{ color: theme.colors.text }}
              onClick={openThemeModal}
            >
              <Palette size={18} color={theme.colors.text} />
              Theme
            </button>
            <button
              onClick={() => setDisplayMode("text")}
              className="px-3 py-1 rounded-lg font-semibold transition"
              style={{
                backgroundColor:
                  displayMode === "text"
                    ? theme.colors.logoBackground
                    : "transparent",
                color:
                  displayMode === "text"
                    ? theme.colors.logoText
                    : theme.colors.text,
                border: `1px solid ${theme.colors.text}`,
              }}
            >
              Text
            </button>
            
            <button
              onClick={() => setDisplayMode("pie")}
              className="px-3 py-1 rounded-lg font-semibold transition"
              style={{
                backgroundColor:
                  displayMode === "pie"
                    ? theme.colors.logoBackground
                    : "transparent",
                color:
                  displayMode === "pie"
                    ? theme.colors.logoText
                    : theme.colors.text,
                border: `1px solid ${theme.colors.text}`,
              }}
            >
              Pie
            </button>
          </motion.div>
        </div>
      </div>

      {/* Share Button */}
      <div className="flex items-center gap-2">
      <div className="flex items-center gap-2">
  <button
   onClick={() => {
    if (!user) {
      showNotification(
        <>Must <a href="/login" className="font-bold underline hover:text-blue-600 transition-colors">make an account</a> to share timer</>
      );
        return;
    }
    if (handleShare) handleShare();
  }}
  
    className="flex items-center gap-2 px-3 py-2 rounded-lg font-semibold transition"
    style={{
      color: theme.colors.text,
      fontSize: "1.05rem",
      boxShadow: "0 px 8px rgba(0,0,0,0.09)",
    }}
  >
    Share
  </button>
  {/* Account/Login Button */}
  <button
      onClick={() => navigate(user ? "/account" : "/login")}
      className="flex items-center gap-2 px-3 py-2 rounded-lg font-semibold transition"
      style={{
        color: theme.colors.text,
        fontSize: "1.05rem",
        boxShadow: "0 px 8px rgba(0,0,0,0.09)",
        border: `1.5px solid ${theme.colors.logoBackground}`,
        }}
      >
        <User size={18} />
        {/* Optionally, show user's display name */}
        {user ? (user.displayName || "Account") : "Login"}
      </button>
</div>

</div>
    </div>
    </>
  );
}
